// Members.js
import React, { useState, useEffect, useContext } from "react";
import MemberForm from "../../components/Members/MemberForm";
import MemberList from "../../components/Members/MemberList";
import { fetchWorkspaces } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";
import { 
  FiUsers, 
  FiUserPlus, 
  FiHome,
  FiChevronDown,
  FiSettings,
  FiSearch,
  FiFilter,
  FiPlus,
  FiMail,
  FiUser,
  FiKey
} from "react-icons/fi";
import "./Members.css";

const Members = () => {
  const { user } = useContext(AuthContext);
  const [refresh, setRefresh] = useState(false);
  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    if (!user?.id) return;

    const loadWorkspaces = async () => {
      const data = await fetchWorkspaces(user.id);
      setWorkspaces(data || []);
      if (data?.length) setWorkspaceId(data[0].id);
    };

    loadWorkspaces();
  }, [user]);

  // Handle responsiveness
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleRefresh = () => {
    setRefresh(!refresh);
  };

  return (
    <div className="members-container">
      {/* Header */}
      <div className="members-header">
        <div className="header-left">
          <div className="header-icon">
            <FiUsers />
          </div>
          <div>
            <h1 className="members-title">Team Members</h1>
            <p className="members-subtitle">
              Manage workspace members and permissions
            </p>
          </div>
        </div>
        
        {/* Workspace Selector & Actions */}
        <div className="header-right">
          {workspaces.length > 0 && (
            <div className="workspace-selector-wrapper">
              <div className="selector-container">
                <FiHome className="selector-icon" />
                <select
                  className="workspace-select"
                  value={workspaceId || ""}
                  onChange={(e) => setWorkspaceId(Number(e.target.value))}
                >
                  {workspaces.map((ws) => (
                    <option key={ws.id} value={ws.id}>
                      {ws.name}
                    </option>
                  ))}
                </select>
                <FiChevronDown className="selector-arrow" />
              </div>
            </div>
          )}

        </div>
      </div>


      {/* Main Content Grid */}
      <div className="members-grid">
        {/* Add Member Card */}
        <div className="card add-member-section">
          <div className="card-header">
            <div className="card-title">
              <FiUserPlus className="card-icon" />
              Invite New Member
            </div>
          </div>
          <div className="card-body">
            {workspaceId ? (
              <>
                
                {/* Actual Form */}
                <MemberForm
                  workspace_id={workspaceId}
                  onMemberCreated={handleRefresh}
                />
              </>
            ) : (
              <div className="empty-state">
                <FiUsers className="empty-icon" />
                <p>Select a workspace to add members</p>
              </div>
            )}
          </div>
        </div>

        {/* Members List Card */}
        <div className="card members-list-section">
          <div className="card-header">
            <div className="card-header-content">
              <div className="card-title">
                <FiUsers className="card-icon" />
                Team Members
              </div>
              {isMobile && (
                <button className="mobile-add-btn" onClick={handleRefresh}>
                  <FiPlus />
                </button>
              )}
            </div>
            
            {/* Mobile Search */}
            {isMobile && (
              <div className="mobile-search-container">
                <FiSearch className="mobile-search-icon" />
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="mobile-search-input"
                />
              </div>
            )}
          </div>
          <div className="card-body">
            {workspaceId ? (
              <>
                         
                {/* Actual Member List */}
                <MemberList
                  workspace_id={workspaceId}
                  refresh={refresh}
                  searchTerm={searchTerm}
                />
              </>
            ) : (
              <div className="empty-state">
                <FiSettings className="empty-icon" />
                <p>Select a workspace to view members</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Floating Action Button */}
      {isMobile && (
        <button className="floating-action-btn" onClick={handleRefresh}>
          <FiPlus />
        </button>
      )}
    </div>
  );
};

export default Members;